/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_SupportInputs */

const en_contact_support = /** @type {(inputs: Contact_SupportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contact Support`)
};

const fr_contact_support = /** @type {(inputs: Contact_SupportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contacter le support`)
};

const de_contact_support = /** @type {(inputs: Contact_SupportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontaktieren Sie den Support.`)
};

const it_contact_support = /** @type {(inputs: Contact_SupportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contatta l'assistenza`)
};

const ru_contact_support = /** @type {(inputs: Contact_SupportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Связаться со службой поддержки`)
};

const es_contact_support = /** @type {(inputs: Contact_SupportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contactar con soporte técnico`)
};

const zh_cn2_contact_support = /** @type {(inputs: Contact_SupportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`联系客服`)
};

const ja_contact_support = /** @type {(inputs: Contact_SupportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`サポートに問い合わせる`)
};

const hi_contact_support = /** @type {(inputs: Contact_SupportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`समर्थन से संपर्क करें`)
};

const pt_pt2_contact_support = /** @type {(inputs: Contact_SupportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contate o suporte`)
};

/**
* | output |
* | --- |
* | "Contact Support" |
*
* @param {Contact_SupportInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const contact_support = /** @type {((inputs?: Contact_SupportInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_SupportInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_contact_support(inputs)
	if (locale === "de") return de_contact_support(inputs)
	if (locale === "it") return it_contact_support(inputs)
	if (locale === "ru") return ru_contact_support(inputs)
	if (locale === "es") return es_contact_support(inputs)
	if (locale === "zh-CN") return zh_cn2_contact_support(inputs)
	if (locale === "ja") return ja_contact_support(inputs)
	if (locale === "hi") return hi_contact_support(inputs)
	if (locale === "pt-PT") return pt_pt2_contact_support(inputs)
	return en_contact_support(inputs)
});